module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAmCAYAAAC29NkdAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADpSURBVFhH7c6vCsJQFMfxvY3VYhetvseaIEaL0SIYhBmNBqs2i2BxwSKCNkUQfImj57ITBB13O+f+Ue8XfrCNu8snAoD6c31fh0B88LbvBs7jMdyP1+zNTbnAQSWGbtRyCtUC0lxACwFdQEsBaTag2sBNsoSk0XsB0kxCtYG3/Vl9OyxSq9DCQMoWtDSQQujEIJQNpBS0KQ8VA1LSUHEgJQU1BqS4UONA6hN0WG1nJ95nDUghdFTr+AvELttTALIKQG4ByO0/gbvZWl0ssXS6kgea2m8D8WcbyysX6EMByC0AuQUgN8+BAA9QP1b1sMyz7AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/publicSTP.png
// module id = 134
// module chunks = 0